__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "overviewappui";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@azure/msal-browser", "2.39.0", function() { return __webpack_require__.e(177).then(function() { return function() { return __webpack_require__(94177); }; }); });
			register("@azure/msal-react", "1.5.13", function() { return Promise.all([__webpack_require__.e(564), __webpack_require__.e(914), __webpack_require__.e(751), __webpack_require__.e(438)]).then(function() { return function() { return __webpack_require__(97564); }; }); });
			register("@fortius/prime-ui", "1.1.1579", function() { return Promise.all([__webpack_require__.e(517), __webpack_require__.e(102), __webpack_require__.e(914), __webpack_require__.e(687)]).then(function() { return function() { return __webpack_require__(79102); }; }); });
			register("@fortius/primefaces-themes", "0.0.135", function() { return Promise.all([__webpack_require__.e(310), __webpack_require__.e(811)]).then(function() { return function() { return __webpack_require__(49811); }; }); });
			register("axios", "1.13.2", function() { return Promise.all([__webpack_require__.e(84), __webpack_require__.e(745)]).then(function() { return function() { return __webpack_require__(62084); }; }); });
			register("lodash", "4.17.21", function() { return __webpack_require__.e(536).then(function() { return function() { return __webpack_require__(53536); }; }); });
			register("react-async", "10.0.1", function() { return Promise.all([__webpack_require__.e(914), __webpack_require__.e(72)]).then(function() { return function() { return __webpack_require__(27072); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(950), __webpack_require__.e(914)]).then(function() { return function() { return __webpack_require__(97950); }; }); });
			register("react-router-dom", "5.3.4", function() { return Promise.all([__webpack_require__.e(74), __webpack_require__.e(914), __webpack_require__.e(766)]).then(function() { return function() { return __webpack_require__(6693); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(43).then(function() { return function() { return __webpack_require__(65043); }; }); });
			register("styled-components", "5.3.11", function() { return Promise.all([__webpack_require__.e(121), __webpack_require__.e(914)]).then(function() { return function() { return __webpack_require__(22121); }; }); });
			initExternal(88909);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};